import React from 'react'
import { useI18n } from '../../i18n'
import AssetContextPanel from './AssetContextPanel'
import styles from '../../styles/components/assets/AssetsInformationSystems.module.scss'
import type { AssetOperationalDetail, AssetOperationalSummaryRow } from '../../services/assetOperationalApi'
import type { AssetPanelContext } from './assetPanelContext'

interface Props {
  detail: AssetOperationalDetail
  summaryRow?: AssetOperationalSummaryRow | null
  panelContext: AssetPanelContext
  onContextChange: (ctx: AssetPanelContext) => void
  onClose: () => void
  onRefresh: () => Promise<void>
  onEdit?: () => void
  onScan?: () => void
  onOpenSystem?: (systemId: string) => void
  informationSystems?: import('../../services/informationSystemsApi').InformationSystemSummary[]
  onLinkToSystem?: (systemId: string) => Promise<void>
  onUnlinkFromSystem?: (systemId: string) => Promise<void>
  linkingToSystem?: boolean
}

export default function AssetPassportPanel(props: Props) {
  return <AssetContextPanel {...props} />
}

export function AssetPassportPanelEmptyState() {
  const { t } = useI18n()
  return (
    <div className={styles.detailsPanelEmpty}>
      {t('assets.assetPassport.selectAssetHint', 'Select an asset to view operational intelligence.')}
    </div>
  )
}
